// Author YuJiaBei
// 派工
// 基于SithMesPrdPpOperation，不需要save
// Date 2020-10-04 06:46:06

class SithMesPrdPpOperation {
    constructor({
                    id = null,
                }
                    = {}) {
        this.id = id;
    }
}

function newEntity() {
    return new SithMesPrdPpOperation();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'orderCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.materialDescription',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'orderType',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.orderType',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'wbsCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.wbsCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prdPpStatusId',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpStatusId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'prdPpStatusName',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.prdPpStatusName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'operationDescription',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationDescription',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'workCenterCode',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workCenterCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ctrlKey',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.ctrlKey',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'operationQuantity',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.operationQuantity',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'systemStatus',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.systemStatus',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'confirmUser',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.confirmUser',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'finishQuantity',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.finishQuantity',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'scrap',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.scrap',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'workHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.workHour',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'bufferHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.bufferHour',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'transferHour',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.transferHour',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'baseBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseBeginTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'baseEndTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseEndTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'baseMstLocationId',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.baseMstLocationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'forecastBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastBeginTime',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'forecastFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastFinishTime',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'forecastMstLocationName',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastMstLocationName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'actualBeginTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualBeginTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'actualFinishTime',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualFinishTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'actualMstLocationId',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualMstLocationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'isLocked',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.isLocked',
            sortable: true,
            form: {
                type: 'boolean'
            }
        },
        {
            key: 'forecastRemark',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.forecastRemark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'actualExecutionRemark',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.actualExecutionRemark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'sapChangedFlag',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.sapChangedFlag',
            sortable: true,
            form: {
                type: 'select'
                , options: [
                    {value: '0', text: '未变化'},
                    {value: '1', text: '从未释放到已释放'},
                    {value: '2', text: '关键信息变更'},
                    {value: '3', text: '删除'}
                ]
            }
        },
        {
            key: 'remark',
            label: 'label.sith.prd.sithMesPrdPpOperation.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea'
            }
        }
    ]);
}

const filter = {
    orderCodeFilter: "",

    prdPpHeaderIdFilter: "",
    prdPpStatusIdFilter: "",
    deleteFlagFilter: "",
    operationDescriptionFilter: "",
    workCenterCodeFilter: "",
    ctrlKeyFilter: "",
    sapChangedFlagFilter: "",
    baseBeginTimeRteFilter: "",
    baseBeginTimeLteFilter: "",
    baseEndTimeRteFilter: "",
    baseEndTimeLteFilter: "",
    baseMstLocationIdFilter: "",
    forecastBeginTimeRteFilter: "",
    forecastBeginTimeLteFilter: "",
    forecastFinishTimeRteFilter: "",
    forecastFinishTimeLteFilter: "",
    forecastMstLocationIdFilter: "",
    forecastMstLocationNameFilter: "",
    forecastMstLocationIdInFilter: "",
    actualBeginTimeRteFilter: "",
    actualBeginTimeLteFilter: "",
    actualFinishTimeRteFilter: "",
    actualFinishTimeLteFilter: "",
    actualMstLocationIdFilter: "",
    isLockedFilter: "",
    forecastRemarkFilter: "",
    actualExecutionRemarkFilter: ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'prdPpHeaderIdFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpHeaderId',
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'sithMesPrdPpHeader'
            , correspondingField: 'id'
        }
    },
    {
        key: 'prdPpStatusIdFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.prdPpStatusId',
        disabled: false,
        form: {
            type: 'entitySelect'
            , entity: 'sithMesPrdPpStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.orderCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'operationDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.operationDescription',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'workCenterCodeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.workCenterCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'ctrlKeyFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.ctrlKey',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'sapChangedFlagFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.sapChangedFlag',
        disabled: false,
        form: {
            type: 'select'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未变化'},
                {value: '1', text: '从未释放到已释放'},
                {value: '2', text: '关键信息变更'},
                {value: '3', text: '删除'}
            ]
        }
    },
    {
        key: 'forecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeRte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'forecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastBeginTimeLte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'forecastFinishTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeRte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'forecastFinishTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastFinishTimeLte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'forecastMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.forecastMstLocationName',
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"forecastMstLocationId":"id"}'
        }
    },
    {
        key: 'isLockedFilter',
        label: 'label.sith.prd.sithMesPrdPpOperation.filter.isLocked',
        disabled: false,
        form: {
            type: 'boolean'
        }
    },
];


export {SithMesPrdPpOperation, newEntity, gridFields, fields, filterFields, filter, filterConfigs}
